var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgI4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9583 2.16669H8.04167C7.17501 2.16669 6.46667 2.86669 6.46667 3.73335V4.51669C6.46667 5.38335 7.16667 6.08335 8.03334 6.08335H11.9583C12.825 6.08335 13.525 5.38335 13.525 4.51669V3.73335C13.5333 2.86669 12.825 2.16669 11.9583 2.16669Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3667 4.51665C14.3667 5.84165 13.2833 6.92498 11.9583 6.92498H8.04167C6.71667 6.92498 5.63334 5.84165 5.63334 4.51665C5.63334 4.04998 5.13334 3.75832 4.71667 3.97498C3.54167 4.59998 2.74167 5.84165 2.74167 7.26665V15.1083C2.74167 17.1583 4.41667 18.8333 6.46667 18.8333H13.5333C15.5833 18.8333 17.2583 17.1583 17.2583 15.1083V7.26665C17.2583 5.84165 16.4583 4.59998 15.2833 3.97498C14.8667 3.75832 14.3667 4.04998 14.3667 4.51665ZM10.3167 14.625H6.66667C6.325 14.625 6.04167 14.3417 6.04167 14C6.04167 13.6583 6.325 13.375 6.66667 13.375H10.3167C10.6583 13.375 10.9417 13.6583 10.9417 14C10.9417 14.3417 10.6583 14.625 10.3167 14.625ZM12.5 11.2916H6.66667C6.325 11.2916 6.04167 11.0083 6.04167 10.6666C6.04167 10.325 6.325 10.0416 6.66667 10.0416H12.5C12.8417 10.0416 13.125 10.325 13.125 10.6666C13.125 11.0083 12.8417 11.2916 12.5 11.2916Z",
    fill: "#202020"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgI4);
export default __webpack_public_path__ + "static/media/i4.c5066c847dd359842b85c221378618a9.svg";
export { ForwardRef as ReactComponent };